import { gql } from '@apollo/client/core';

export const emailControllerNote = gql`
  mutation emailControllerNote($input: EmailRequest) {
    emailControllerNote(input: $input) {
      result
    }
  }
`;
